export default {
  compute_cluster: {
    updated: {
      action: 'commit',
      moduleName: 'compute',
      actionName: 'compute/UPDATE_STATUS',
      payloadFormatter: object => object.status,
      ability: { action: 'read', subject: 'compute_cluster' }
    }
  },
  statistics: {
    updated: {
      action: 'commit',
      moduleName: 'compute',
      actionName: 'compute/SET_COMPUTE_STATS',
      ability: { action: 'read', subject: 'compute_cluster_stat' }
    }
  },
  nodes: {
    created: {
      action: '$takeLast',
      moduleName: 'computeNodes',
      actionName: 'computeNodes/FETCH_ITEM',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_node' }
    },
    updated: {
      action: '$takeLast',
      moduleName: 'computeNodes',
      actionName: 'computeNodes/FETCH_ITEM',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_node' }
    }
  },
  node_statistics: {
    updated: {
      action: 'dispatch',
      moduleName: 'computeNodes',
      actionName: 'computeNodes/CHANGE',
      payloadFormatter: object => ({
        ...object,
        id: object.node_id
      }),
      ability: { action: 'update', subject: 'compute_nodes' }
    }
  },
  servers: {
    updated: {
      action: '$takeLast',
      moduleName: 'servers',
      actionName: 'servers/FETCH_VIEWS_BY_NOTIFICATION',
      payloadFormatter: object => ({ id: object.id, params: { with_stats: true } }),
      ability: { action: 'read', subject: 'compute_server' }
    },
    created: {
      action: '$takeLast',
      moduleName: 'servers',
      actionName: 'servers/FETCH_VIEWS_BY_NOTIFICATION',
      payloadFormatter: object => ({ id: object.id, params: { with_stats: true } }),
      ability: { action: 'read', subject: 'compute_server' }
    },
    deleted: {
      action: 'dispatch',
      moduleName: 'servers',
      actionName: 'servers/ABORT_AND_REMOVE',
      payloadFormatter: object => ({ actionName: 'servers/FETCH_VIEWS_BY_NOTIFICATION', payload: { id: object.id, params: { with_stats: true } } }),
    }
  },
  networks: {
    updated: {
      action: '$takeLast',
      moduleName: 'networks',
      actionName: 'networks/FETCH_VIEWS_BY_NOTIFICATION',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_networks' }
    },
    created: {
      action: '$takeLast',
      moduleName: 'networks',
      actionName: 'networks/FETCH_VIEWS_BY_NOTIFICATION',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_networks' }
    },
    deleted: {
      action: 'dispatch',
      moduleName: 'networks',
      actionName: 'networks/ABORT_AND_REMOVE',
      payloadFormatter: object => ({ actionName: 'networks/FETCH_VIEWS_BY_NOTIFICATION', payload: { id: object.id } }),
    }
  },
  router_interfaces: {
    deleted: {
      action: '$takeLast',
      moduleName: 'routers',
      actionName: 'routers/FETCH_ROUTER_INTERFACES',
      payloadFormatter: object => ({ id: object.router_id }),
      ability: { action: 'read', subject: 'compute_routers_router_interfaces' }
    },
    created: {
      action: '$takeLast',
      moduleName: 'routers',
      actionName: 'routers/FETCH_ROUTER_INTERFACES',
      payloadFormatter: object => ({ id: object.router_id }),
      ability: { action: 'read', subject: 'compute_routers_router_interfaces' }
    }
  },
  floating_ips: {
    created: {
      action: '$takeLast',
      moduleName: 'floatingIps',
      actionName: 'floatingIps/FETCH_VIEWS_BY_NOTIFICATION',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_networks_floating_ips' }
    },
    updated: {
      action: '$takeLast',
      moduleName: 'floatingIps',
      actionName: 'floatingIps/FETCH_VIEWS_BY_NOTIFICATION',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_networks_floating_ips' }
    },
    deleted: {
      action: 'dispatch',
      moduleName: 'floatingIps',
      actionName: 'floatingIps/ABORT_AND_REMOVE',
      payloadFormatter: object => ({ actionName: 'floatingIps/FETCH_VIEWS_BY_NOTIFICATION', payload: { id: object.id } }),
    }
  },
  load_balancers: {
    created: {
      action: '$takeLast',
      moduleName: 'lbaas',
      actionName: 'lbaas/loadBalancers/FETCH_ITEM',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_load_balancer' }
    },
    updated: {
      action: '$takeLast',
      moduleName: 'lbaas',
      actionName: 'lbaas/loadBalancers/FETCH_ITEM',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_load_balancer' }
    },
    deleted: {
      action: 'dispatch',
      moduleName: 'lbaas',
      actionName: 'lbaas/loadBalancers/ABORT_AND_REMOVE',
      payloadFormatter: object => ({ actionName: 'lbaas/loadBalancers/FETCH_ITEM', payload: { id: object.id } }),
    }
  },
  load_balancer_pools: {
    created: {
      action: '$takeLast',
      moduleName: 'lbaas',
      actionName: 'lbaas/loadBalancerPools/FETCH_ITEM',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_load_balancing_pool' }
    },
    updated: {
      action: '$takeLast',
      moduleName: 'lbaas',
      actionName: 'lbaas/loadBalancerPools/FETCH_ITEM',
      payloadFormatter: object => ({ id: object.id, merge: false }),
      ability: { action: 'read', subject: 'compute_load_balancing_pool' }
    },
    deleted: {
      action: 'dispatch',
      moduleName: 'lbaas',
      actionName: 'lbaas/loadBalancerPools/ABORT_AND_REMOVE',
      payloadFormatter: object => ({ actionName: 'lbaas/loadBalancerPools/FETCH_ITEM', payload: { id: object.id } }),
    }
  },
  ipsec_site_connections: {
    created: {
      action: '$takeLast',
      moduleName: 'vpn',
      actionName: 'vpn/FETCH_ITEM',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_vpn_ipsec_site_connection' }
    },
    updated: {
      action: '$takeLast',
      moduleName: 'vpn',
      actionName: 'vpn/FETCH_ITEM',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_vpn_ipsec_site_connection' }
    },
    deleted: {
      action: 'dispatch',
      moduleName: 'vpn',
      actionName: 'vpn/ABORT_AND_REMOVE',
      payloadFormatter: object => ({ actionName: 'vpn/FETCH_ITEM', payload: { id: object.id } }),
    }
  },
  traits: {
    created: {
      action: '$takeLast',
      moduleName: 'computePlacements',
      actionName: 'computePlacements/FETCH_ITEM',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_trait' }
    },
    updated: {
      action: '$takeLast',
      moduleName: 'computePlacements',
      actionName: 'computePlacements/FETCH_ITEM',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_trait' }
    },
    deleted: {
      action: 'dispatch',
      moduleName: 'computePlacements',
      actionName: 'computePlacements/ABORT_AND_REMOVE',
      payloadFormatter: object => ({ actionName: 'computePlacements/FETCH_ITEM', payload: { id: object.id } }),
      ability: { action: 'read', subject: 'compute_trait' }
    }
  },
  backup_plans: {
    updated: {
      action: '$takeLast',
      moduleName: 'computeBackupPlans',
      actionName: 'computeBackupPlans/FETCH_VIEWS_BY_NOTIFICATION',
      payloadFormatter: object => ({ id: object.id, merge: false }),
      ability: { action: 'read', subject: 'compute_backup_plan' }
    },
    created: {
      action: '$takeLast',
      moduleName: 'computeBackupPlans',
      actionName: 'computeBackupPlans/FETCH_VIEWS_BY_NOTIFICATION',
      payloadFormatter: object => ({ id: object.id }),
      ability: { action: 'read', subject: 'compute_backup_plan' }
    },
    deleted: {
      action: 'dispatch',
      moduleName: 'computeBackupPlans',
      actionName: 'computeBackupPlans/ABORT_AND_REMOVE',
      payloadFormatter: object => ({ actionName: 'computeBackupPlans/FETCH_VIEWS_BY_NOTIFICATION', payload: { id: object.id } }),
    }
  }
};
